import requestAction from '../../utils/requestAction'

export const fetchOrders = (params: string, handleResponse?: (response: any) => void) =>
  requestAction('ORDER_LIST', params)(`orders`, 'GET',
undefined,
undefined,
undefined,
(_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response) })
